<template>
<ul class="map-main-menu">
	<li>
		<router-link to="/">
			<div class="icon logo-image"></div>
		</router-link>
	</li>
	<li>
		<router-link to="/map/search">
			<div class="icon menu-icon-search"></div>
		</router-link>
	</li>
	<li>
		<a>
			<div class="icon icon-chat" />
		</a>
	</li>
	<li>
		<router-link to="/dashboard/create-campaign">
			<div class="icon icon-dash" />
		</router-link>
	</li>
</ul>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.map-main-menu {
	background: #141a21;
	margin: 0;
	padding: 0;
	width: 56px;
	position: absolute;
	height: 100%;
	z-index: 2;
	list-style: none;

	li {

		a {
			padding: 14px 15px;
			border-bottom: 1px solid #050607;
			cursor: pointer;
			display: block;
		}

		&:not(:first-child):hover a {
			background: #4ba98b;
		}
		.icon {
			display: block;
			width: 25px;
			height: 25px;
			margin: 0 auto;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		}
		.menu-icon-search {
			background-image: url('../../../assets/images/search.svg')
		}
		.icon-chat {
			background-image: url('../../../assets/images/chat.svg')
		}
		.icon-dash {
			background-image: url('../../../assets/images/dash.svg')
		}
		.logo-image {
			background-image: url('../../../assets/images/logo_image.png');
		}
		.icon:before {
			margin: 0;
			font-size: 26px;
			color: #fff;
		}
	}
}
</style>
